<script>
import resources from './resources'

export default {
  name: 'dependents',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(icon='', title='Meus Dependentes')
    .col-xs-12.content
      .container-fluid.zero-margin
        .row
          //-- card
          card-add(label='Adicionar<br>Novo Dependente', route='settings.dependents.create', icon='')
          //-- dependent
          dependent(@on-delete='doDelete', v-for='dependent in dependents', :key='dependent.id', :dependent='dependent')
        .pagination
          pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/settings/dependents/index/dependents.vue